import React from 'react'
import R from 'ramda'
import {defineMessages, injectIntl} from 'react-intl'

import I18nSelect from './I18nSelect'
import selectionProps from '../utils/selectionProps'

const m = defineMessages({
  priceasc: {
    id: 'PriceAsc',
    defaultMessage: 'Price ascending',
  },
  pricedesc: {
    id: 'PriceDesc',
    defaultMessage: 'Price descending',
  },
  proximity: {
    id: 'Proximity',
    defaultMessage: 'Proximity',
  },
  pertinence: {
    id: 'Pertinence',
    defaultMessage: 'Pertinence'
  },
  date: {
    id: 'Date',
    defaultMessage: 'Date',
  }
})

const SortColumnField = ({options, sortColumn, onChange, intl}) => {
  const translatOption = option => ({
    name: intl.formatMessage(m[option.name]), 
    code: option.name
  })
  const translatedOptions = R.map(translatOption, options.sort)
  return <I18nSelect 
            searchable={false}
            clearable={false}
            options={translatedOptions}
            value={sortColumn}
            valueKey="code"
            labelKey="name"
            className="xs-select"
            onChange={ s => onChange(R.prop('code', s))}
            />
  
}

SortColumnField.propTypes = {
  sortColumn: React.PropTypes.string.isRequired,
  options: React.PropTypes.shape({
    sort: React.PropTypes.arrayOf(React.PropTypes.shape({
      name: React.PropTypes.string.isRequired
    })).isRequired
  }).isRequired,
  onChange: React.PropTypes.func.isRequired,
}

export default injectIntl(SortColumnField)



/** WEBPACK FOOTER **
 ** ./app/components/SortColumnField.jsx
 **/